var render = function render(){var _vm=this,_c=_vm._self._c;return _c('swiper',{staticClass:"ads",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.adsList),function(item){return _c('swiper-slide',{key:item.id,staticClass:"swiper-slide"},[_c('img',{staticClass:"cover-img",attrs:{"src":item.cover.url},on:{"click":function($event){$event.stopPropagation();return _vm.onPageOpen(item)}}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }